import React from "react";
import { useParams } from "react-router-dom";
import { artworks } from "./artworks";
import { Carousel, Container, Row, Col } from "react-bootstrap";

function ArtPage() {
  const { id } = useParams();
  const art = artworks.find((item) => item.id === id);

  if (!art) return <p>Artwork not found</p>;

  const status = art.status || "available";
  const subject = encodeURIComponent(`Inquiry: ${art.title}`);
  const mailtoLink = `mailto:skyjungofficial@gmail.com?subject=${subject}`;

  return (
    <Container className="art-detail">
      <Row >
        <Col md={8}>
          <Carousel variant="light">
            {art.images.map((img, index) => (
              <Carousel.Item key={index}>
                <div className="carousel-image-wrapper">
                  <img className="d-block w-100" src={img} alt={`${art.title} ${index + 1}`} />
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </Col>
        <Col md={2} className="art-details-text">
          <p style={{fontStyle: "italic", fontSize: '1rem', margin: 0}}>{art.title}</p>
          <p style={{fontSize: '0.8rem'}}>{art.medium} <br></br> {art.size} <br></br> {art.year}</p>
          {status === "sold" ? (
            <button className="inquire-button sold" disabled>Sold</button>
          ) : status === "reserved" ? (
            <button className="inquire-button sold" disabled>Reserved</button>
          ) : (
            <a href={mailtoLink} className="inquire-button">Inquire</a>
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default ArtPage;
